import { render, staticRenderFns } from "./attend-match-player.vue?vue&type=template&id=0440f92c&scoped=true&"
import script from "./attend-match-player.vue?vue&type=script&lang=js&"
export * from "./attend-match-player.vue?vue&type=script&lang=js&"
import style0 from "./attend-match-player.vue?vue&type=style&index=0&id=0440f92c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0440f92c",
  null
  
)

export default component.exports